import React from 'react'
import {useCustomPreference} from '../../hooks/use-custom-preference'
import {Helmet} from 'react-helmet'
import {useLocation} from 'react-router-dom'

const Digioh = () => {
    const digiohVendorUrl = useCustomPreference('digiohVendorURL')
    const location = useLocation()

    return (
        <>
            {digiohVendorUrl && (
                <Helmet>
                    <script
                        async
                        type="text/javascript"
                        src={`${digiohVendorUrl}?v=${location.pathname}`}
                        data-testid="digioh-script"
                    ></script>
                </Helmet>
            )}
        </>
    )
}

export default Digioh
